import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { geTotalBalance } from "../features/transaction/transactionSlice";
import numberWithCommas from "../utils/numberWithCommas";

export default function Balance() {
  const dispatch = useDispatch();
  const { balance, transactions } = useSelector((state) => state?.transaction);
  
  useEffect(() => {
    dispatch(geTotalBalance());
  }, [dispatch, transactions]);

  return (
    <div className="top_card">
      <p>Your Current Balance</p>
      <h3>
        <span>৳</span> <span>{numberWithCommas(balance)}</span>
      </h3>
    </div>
  );
}
